<template>
  <abk-removed-users-list></abk-removed-users-list>
</template>

<script>
import AbkRemovedUsersList from '../components/AbkRemovedUsersList'
export default {
  name: 'removed-users-list',
  components: { AbkRemovedUsersList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.removed_users_list.title'),
        subtitle: this.$t('views.removed_users_list.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped>

</style>
